import palette from '../palette';

export default {
  colorSecondary: {
    backgroundColor: palette.text.primary,
  },
};
